import React, { useState } from 'react';
import { USER_addres } from '../../API/API';

/**
 * Кнопка «Войти через Яндекс» для АдминПанели.
 *
 * Поток:
 *   1. Юзер жмёт кнопку.
 *   2. Бэк (user-микросервис) отдаёт authorize_url с state.
 *   3. Редирект на oauth.yandex.ru.
 *   4. Яндекс редиректит на /auth/yandex/callback?code&state.
 *   5. YandexCallback.jsx обменивает code на JWT, делает access-check
 *      админки и редиректит в /main (или /no-access).
 */
const YandexLoginButton = ({ disabled }) => {
    const [busy, setBusy] = useState(false);
    const [err, setErr] = useState('');

    const onClick = async () => {
        setBusy(true);
        setErr('');
        try {
            const frontend = window.location.origin;
            const r = await fetch(
                `${USER_addres}/api/v1/users/auth/yandex/start?frontend=${encodeURIComponent(frontend)}`,
                { method: 'GET' },
            );
            const data = await r.json();
            if (!r.ok || !data.authorize_url) {
                setErr(data.message || 'Не удалось начать вход');
                setBusy(false);
                return;
            }
            window.location.href = data.authorize_url;
        } catch (e) {
            setErr('Сеть недоступна');
            setBusy(false);
        }
    };

    return (
        <div style={{ width: '100%' }}>
            <button
                type="button"
                onClick={onClick}
                disabled={disabled || busy}
                style={{
                    width: '100%',
                    height: 44,
                    background: '#000',
                    color: '#fff',
                    border: 'none',
                    borderRadius: 10,
                    fontSize: 15,
                    fontWeight: 600,
                    cursor: (disabled || busy) ? 'not-allowed' : 'pointer',
                    opacity: (disabled || busy) ? 0.6 : 1,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: 10,
                    transition: 'filter 0.15s ease',
                }}
                onMouseOver={(e) => !disabled && !busy && (e.currentTarget.style.filter = 'brightness(1.15)')}
                onMouseOut={(e) => (e.currentTarget.style.filter = 'brightness(1)')}
            >
                <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <circle cx="12" cy="12" r="11" fill="#FC3F1D" />
                    <path d="M13.3 18.5h2.05V5h-3.05c-2.85 0-4.6 1.5-4.6 4 0 1.8.9 2.95 2.45 3.7L7.5 18.5h2.2l2.85-6h.75v6zm-1.05-7.85h-.8c-1.5 0-2.3-.85-2.3-2.3 0-1.5.8-2.2 2.3-2.2h.8v4.5z" fill="#fff" />
                </svg>
                {busy ? 'Открываем Яндекс...' : 'Войти через Яндекс'}
            </button>
            {err && (
                <div style={{ color: '#dc2626', fontSize: 13, marginTop: 6, textAlign: 'center' }}>
                    {err}
                </div>
            )}
        </div>
    );
};

export default YandexLoginButton;
